export default __webpack_public_path__ + "static/media/nouserimage.c96824ec.svg";